import { Injectable } from "@angular/core";
import { IChangePassword, IResetPassword } from "@shared/interfaces/user.interface";
import { Observable } from "rxjs";
import { ApiService } from "./api.service";

@Injectable({
  providedIn: "root",
})
export class UserPasswordService {
  constructor(private api: ApiService) {}

  /**
   * Change users own password
   * @param changePasswordData The new and old password
   * @returns Success or error
   */
  public changePassword(changePasswordData: IChangePassword): Observable<unknown> {
    return this.api.post("user/change-password", changePasswordData) as Observable<unknown>;
  }

  /**
   * Sends a code to the given email to reset password
   * @param email The reference email of the user
   * @returns Success or invalid email
   */
  public forgotPassword(email: string): Observable<unknown> {
    return this.api.post("user/forgot-password", email, undefined) as Observable<unknown>;
  }

  /**
   * Resets the users password
   * @param resetPasswordData The code received by email and the new password
   * @returns Success, wrong code or user not found
   */
  public resetPassword(resetPasswordData: IResetPassword): Observable<unknown> {
    return this.api.post("user/reset-password", resetPasswordData, undefined) as Observable<unknown>;
  }
}
